import { Navigate } from 'react-router-dom';

const ADMIN_ROLES = ['admin', 'staff'];

// Guards a page by login and role. Members go to their dashboard, admin/staff to the member search page.
const RoleRoute = ({ roles, children }) => {
  const authToken = localStorage.getItem('authToken');
  const refreshToken = localStorage.getItem('refreshToken');
  const role = localStorage.getItem('role');

  if (!authToken || !refreshToken) {
    return <Navigate to="/login" replace />;
  }
  if (!roles.includes(role)) {
    return <Navigate to={role === 'member' ? '/dashboard' : '/add_member'} replace />;
  }
  return children;
};

export { ADMIN_ROLES };
export default RoleRoute;
